import React from "react";
import { Grid, Chip, Divider, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  segment: {
    position: "relative",
    top: -5,
    textAlign: "center",
    fontSize: "1.1em",
    fontWeight: "bold",
  },
  divider: {
    position: "relative",
    top: -16,
    zIndex: -999,
  },
}));

interface ActivitySegmentHeaderProps {
  label: string;
}

export const ActivitySegmentHeader: React.FC<ActivitySegmentHeaderProps> = ({
  label,
}) => {
  const classes = useStyles();
  return (
    <Grid item sm={12}>
      <div className={classes.segment}>
        <Chip label={label} />
        <Divider className={classes.divider} />
      </div>
    </Grid>
  );
};
